import { gql, useMutation } from "@apollo/client";

import type { CartType } from "../types";

export const CART_FRAGMENT = gql`
  fragment CartFields on CartType {
    id
    currency
    booking {
      id
    }
    subtotal
    discount
    tax
    inconvenienceFee
    total
    timeslot {
      id
      datetime
      game {
        id
        name
        location {
          id
          company {
            id
            name
          }
        }
      }
      maxPlayers
      minPlayers
      slotsLeft
      pricingCategories {
        vendorCategoryId
        name
        pricePerPerson
        minQuantity
        maxQuantity
      }
    }
    items {
      vendorCategoryId
      name
      quantity
      pricePerPerson
      total
    }
    fees {
      name
      total
    }
    promotions {
      amount
      code
      isActive
      kind
    }
    paymentIntentClientSecret
    expiresAt
  }
`;

const CART_MUTATION = gql`
  ${CART_FRAGMENT}

  mutation updateCart(
    $id: String
    $inconvenienceFee: Boolean
    $items: [CartItemInputType!]!
    $timeslotId: ID!
  ) {
    updateCart(
      id: $id
      inconvenienceFee: $inconvenienceFee
      items: $items
      timeslotId: $timeslotId
    ) {
      cart {
        ...CartFields
      }
    }
  }
`;

interface UpdateCartDataType {
  updateCart: {
    cart: CartType;
  };
}

export interface UpdateCartVariablesType {
  id?: string;
  inconvenienceFee?: boolean;
  items: {
    quantity: number;
    vendorCategoryId: string;
  }[];
  timeslotId: string;
}

export default function useUpdateCart() {
  return useMutation<UpdateCartDataType, UpdateCartVariablesType>(
    CART_MUTATION
  );
}
